const topics = [
  { name: '顶流密会', count: '982W', hot: true },
  { name: '直播翻车', count: '876W', hot: true },
  { name: '税务风波', count: '754W', hot: true },
  { name: '综艺冲突', count: '689W', hot: false },
  { name: '豪门恋情', count: '612W', hot: true },
  { name: '明星婚姻', count: '543W', hot: false },
  { name: '网红塌房', count: '498W', hot: true },
  { name: '选秀黑幕', count: '467W', hot: false },
  { name: '合约纠纷', count: '432W', hot: false },
  { name: '代言风波', count: '389W', hot: true },
  { name: '机场街拍', count: '356W', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            话题广场
          </h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8 ml-4">热门吃瓜话题一站式浏览，点击标签查看相关爆料合集</p>

        <div className="flex flex-wrap gap-3">
          {topics.map((topic) => (
            <a
              key={topic.name}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className={`group relative px-5 py-3 rounded-xl font-medium text-sm transition-all cursor-pointer ${
                topic.hot
                  ? 'bg-primary-50 text-primary-700 hover:bg-primary-100 border border-primary-200'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200 border border-background-200/70'
              }`}
            >
              <span className="relative z-10 whitespace-nowrap">
                {topic.hot && (
                  <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary-500 mr-1.5 align-middle"></span>
                )}
                # {topic.name}
              </span>
              <span className={`ml-2 text-xs ${topic.hot ? 'text-primary-500' : 'text-foreground-500'}`}>
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}